import React from 'react';
import { Header } from '../../node_modules/semantic-ui-react';
import { withGoogleMap, withScriptjs, GoogleMap, Marker, } from "react-google-maps";
import data from '../static/misc/map.json';

const MapWithAMarker = withScriptjs(withGoogleMap(props =>
    <GoogleMap
        bootstrapURLKeys={{
            key:'AIzaSyAyQb82rwysTdq9bUz4UiwHeDVcvaDIUOA',
        }}
        defaultZoom={8}
        defaultCenter={{ lat: 127, lng: 36 }}
    >
        {
            data['features'].map((val, idx) => 
                (
                    <Marker
                        key={idx}
                        position={{ lat: parseInt(val.geometry[0],10), lng: parseInt(val.geometry[1],10) }}
                    />
                )
            )
        }
    </GoogleMap>
  ));

  
export default function Map(props) {
    return(
        <div className='section' id='map'>
            <Header as='h3'>
            Places I've lived/travelled
            </Header>
            <MapWithAMarker 
                googleMapURL="https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=AIzaSyAyQb82rwysTdq9bUz4UiwHeDVcvaDIUOA"
                loadingElement={<div style={{ height: `100%` }} />}
                containerElement={<div style={{ height: `400px` }} />}
                mapElement={<div style={{ height: `100%` }} />}
            />
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/Map.jsx